module.exports = __webpack_public_path__ + "static/result_thewild_wishmas-36f32fb8ea99b096393ba31adfd83d5e.jpg";